// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-menu__content[data-v-7defa945]{border-radius:5px 5px 40px 5px;box-shadow:0 5px 17px 0 rgba(0,0,0,.4)!important;left:0!important;max-width:100vw!important;width:100vw!important;z-index:6!important}.v-list-item__title[data-v-7defa945]{font-size:20px!important;text-overflow:clip;white-space:normal}.gradient-btn[data-v-7defa945]{cursor:default;margin-top:4px}.help-bar[data-v-7defa945]{position:fixed;z-index:9}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
